import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { regex } from '@core/constant/constant';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ErrorTranslationService {
  constructor(private translate: TranslateService) {}

  getMessageError = (error: any) => {
    if (error?.error?.errors && Object.keys(error?.error?.errors).length) {
      let message = '';
      Object.keys(error.error.errors).forEach((name, index) => {
        const listKeyErrors = error.error.errors[name] as string[];
        listKeyErrors.forEach((key, index2) => {
          message += `${
            index || index2 ? '\n' : ''
          }${name}: ${this.translate.instant(`ERROR_RESPONSE.${key}`)}`;
        });
      });
      return message;
    }
    if (error instanceof HttpErrorResponse) {
      const detailError = error.error.detail;
      if (detailError) {
        return this.handleErrorContainHash(detailError);
      }
      if (error.error.error_description) {
        return error.error.error_description;
      }
      return error.error.title || error.error.message;
    }
    if (error instanceof TypeError) {
      return error.message;
    }
    if (error instanceof SyntaxError) {
      return error.message;
    }
    return error;
  };

  splitTypeAndMessage = (error: string) => {
    const split = error.split(':');
    return {
      message: split.length > 1 ? split[1] : split[0],
      type: (split.length > 1 && split[0]) || 'success',
    };
  };

  handleErrorContainHash(message: string) {
    const match = String(message).match(regex.codeErrorsDetail);
    if (match?.length) {
      const id = match ? match[1] : null;
      const updatedText = message.replace(regex.codeErrorsDetail, '_');
      return this.translate.instant(`ERROR_RESPONSE.${updatedText}`, {
        id,
      });
    }
    return message;
  }

}
